import React, { useEffect, useState, useCallback } from 'react';
import Maintenance from './Maintenance';
import LoadSimple from '../../LoadSimple';


const MaintenanceWrapper = ({loading,events,handleChangEdit,server,hosts,groups,users,languaje,mode}) => {
// const [ events, setEvents] = useState([]);  //objeto para guardar los eventos de mantenimiento  mostrar en calendario
// const [ loading, setLoading] = useState([]); // objeto para guardar el estado de visibilidad de loader

// //funcion para get de eventos a api
// const fetchEvents = useCallback(async () => {
//     try{
//         const response = await fetch(server.url+'/api/v1/cassia/maintenance/')
//         const data = await response.json();
//         console.log(data)
//         //asegurar el formato de hora esperado en los eventos 2024-11-10 04:00
//         const formattedEvents = data.data.map((event) => ({
//             ...event,
//             start: event.start_time.replace('T', ' ').slice(0, 16),
//             end: event.end_time.replace('T', ' ').slice(0, 16),
//             title: event.name
//         }));
//         setEvents(formattedEvents) //guardar eventos obtenidos en objeto events
//         console.log("eventos cargados y formateados:", formattedEvents)
//     }catch{
//         console.log('Error al obtener los eventos')
//     }finally{
//         setLoading(false); //Terminar de mostrar el loader
//     }
// },[]);


// useEffect(() => {
//     fetchEvents(); //cargar eventos al montar
// }, [fetchEvents]);

if(loading){
    return <div className="cont-load-user-list">
    <LoadSimple></LoadSimple>
  </div>;
}

return(
    <div className='calendar-wrapper'>
        {/* <h1>Calendario de Mantenimiento</h1> */}
        {/* aqui inyectamos el maintenance component y pasados eventos como argumento */}
        <Maintenance handleChangEdit={handleChangEdit} languaje={languaje} mode={mode} events = {events}  server={server} hosts={hosts} groups={groups} users={users}/>
    </div>
);

};

export default MaintenanceWrapper;